import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import StylesProvider from "./context/StylesProvider";
import VideoProvider from "./context/VideoProvider";
import AudioProvider from "./context/AudioProvider";
import ChartProvider from "./context/ChartProvider";
import VocalInterfaceProvider from "./context/VocalInterfaceProvider";
import { LanguageProvider } from "./hooks/languageService";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* @ts-ignore */}
    <BrowserRouter>
      <StylesProvider>
        <LanguageProvider>
          <VocalInterfaceProvider>
            <VideoProvider>
              <AudioProvider>
                <ChartProvider>
                  <App />
                </ChartProvider>
              </AudioProvider>
            </VideoProvider>
          </VocalInterfaceProvider>
        </LanguageProvider>
      </StylesProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
